import { isArray, find, values, findIndex, flatten, uniq } from 'lodash-es'
import { evalData } from '@ow/utils'
import { FrozenDirection } from './basetable/Column'

const allowEditModalTypes = [
  'number',
  'text',
  'ref',
  'gis',
  'geolocation',
  'userMultiple',
  'dropSelect',
]

const operatorWidthMap = {
  1: 100,
  2: 137,
  3: 180,
  4: 266,
  5: 306,
}
const hiddenTableColumnsType = ['note']

const DEFAULT_WIDTH = {
  NORMAL: 200,
  ID: 150,
  SELECTION: 53,
}

const ID_SLUG = 'tableDataId'

export const canInlineEdit = ({ defs, allow, slugs, code = {}, rowData }) => {
  if (!allow) return false

  if (!allowEditModalTypes.includes(defs.type)) return false

  if (slugs && !slugs.includes(defs.slug)) return false

  if (code[defs.slug]) {
    return evalData(code[defs.slug], rowData)
  }

  return true
}

export const getCellEvent = ({ defs, hooks, rowData }) => {
  switch (defs.event) {
    case 'detail':
      return () => hooks.showTbDetail({ currentData: rowData })
    default:
      return null
  }
}

const findIDField = (fields) => {
  return find(fields, (o) => o.slug === ID_SLUG)
}

const clacWidth = (config, idField, columns) => {
  if (columns.length === 0) {
    return DEFAULT_WIDTH.NORMAL
  }
  if (config.width === 'auto' && config.tbWidth) {
    let tbWdith = config.tbWidth - DEFAULT_WIDTH.SELECTION - 20
    if (idField) {
      tbWdith -= idField.width || DEFAULT_WIDTH.ID
    }
    return Math.floor(tbWdith / columns.length)
  }
  return DEFAULT_WIDTH.NORMAL
}

const clacSticky = (col, showType) => {
  if ((col.slug === ID_SLUG || col.showType === 'sticky') && !showType) {
    return FrozenDirection.LEFT
  }

  if (col.showType === 'sticky-right' || showType === 'sticky-right') {
    return FrozenDirection.RIGHT
  }

  return false
}

// 合并单元格相关
const calColSlug = 'standard_1'
export const calculationMergeCellInfo = (data) => {
  if (!data) {
    return null
  }
  const finalArr = []

  data.forEach((item) => {
    const { allObjectIds, merge } = item
    const obj = merge.find((v) => v.slug === calColSlug)
    if (obj) {
      const { rowSpan } = obj || {}
      const arr = uniq([...allObjectIds])
      const calColSlugRowSpanObjectIds = arr.splice(0, rowSpan)
      finalArr.push(calColSlugRowSpanObjectIds)
    }
  })
  const obj = {}

  finalArr.forEach((item, index) => {
    // 偶行
    if ((index + 1) % 2 === 0) {
      item.forEach((v) => {
        obj[v] = { even: true }
      })
    } else {
      item.forEach((v) => {
        obj[v] = { even: false }
      })
    }
  })
  return obj
}

export const transformMergeCellInfo = (data) => {
  if (!data) {
    return null
  }
  const map = {}
  data.forEach((v) => {
    map[v.objectId] = v.merge
  })
  return map
}

export const transformColumns = (cloumns, data = []) => {
  if (!data) {
    return null
  }
  const rowInfo = transformMergeCellInfo(data)
  const arr = flatten(values(rowInfo))

  arr.forEach((info) => {
    const { slug } = info

    const index = findIndex(cloumns, (v) => v.key === slug)

    if (index > -1 && !cloumns[index].colSpan) {
      cloumns[index].colSpan = (id, mergeCellInfo) => {
        const obj = (mergeCellInfo[id] || []).find((v) => v.slug === slug)
        return obj.colSpan
      }
    }
    if (index > -1 && !cloumns[index].rowSpan) {
      cloumns[index].rowSpan = (id, mergeCellInfo) => {
        const obj = (mergeCellInfo[id] || []).find((v) => v.slug === slug)
        return obj.rowSpan
      }
    }
  })

  return cloumns
}

export const transformTableFieldsDefs = function (
  fields,
  config,
  hooks,
  {
    isRenderOperateTable,
    showFixedOperation,
    operatorNum,
    fixedOperationWidth,
    dataCheckDisabled,
  }
) {
  return () => {
    const {
      mergeCellInfo,
      isShowSelections,
      isDraggable,
      operateStyle = {},
    } = config
    const idField = findIDField(fields)
    const tableDataIdColumn = idField && {
      key: ID_SLUG,
      title: (idField && idField.title) || '编号',
      dataKey: ID_SLUG,
      width: idField.width || DEFAULT_WIDTH.ID,
      resizable: idField.resizable !== false,
      sortable: false,
      frozen: clacSticky(
        idField,
        ((config.fields || []).find((v) => v.slug === ID_SLUG) || {}).showType
      ),
      defs: idField,
      hooks,
    }

    // 优化
    const fixedOperateColumn = showFixedOperation && {
      key: 'fixedOperation',
      title: '操作',
      dataKey: 'fixedOperation',
      width: fixedOperationWidth || operatorWidthMap[operatorNum] || 0,
      resizable: false,
      sortable: false,
      frozen: clacSticky({ showType: 'sticky-right' }),
      defs: {
        type: 'operate',
        slug: '__fixedOperation__',
      },
      style: {
        padding: '0 0 0 24px',
      },
      hooks,
    }

    const columns = []

    if (isShowSelections && !isDraggable) {
      columns.push({
        sortable: false,
        defs: {
          dataCheckDisabled,
          type: 'selection',
          slug: '__selection__',
        },
        hooks,
        width: DEFAULT_WIDTH.SELECTION,
        flexShrink: 0,
        resizable: false,
        frozen: FrozenDirection.LEFT,
        key: '__selection__',
        style: {
          padding: '0 0 0 14px',
        },
        // onChange: handleSelectChange,
      })
    }

    if (!fields) {
      return columns
    }

    if (isRenderOperateTable) {
      // 新加
      columns.push({
        sortable: false,
        defs: {
          type: 'operate',
          slug: '__operate__',
        },
        hooks,
        width: operateStyle.width || 350,
        flexShrink: 1,
        resizable: false,
        frozen: FrozenDirection.RIGHTOPT,
        key: '__operate__',
        // style: {
        //   position: 'absolute',
        //   overflow: 'visible',
        //   right: '0',
        // },
        // onChange: handleSelectChange,
      })
    }

    const columnsMap = {}

    fields.forEach((f) => {
      if (f.slug) {
        columnsMap[f.slug] = f
      }
    })

    const visibleFields = []
    const hasFieldsMask = isArray(config.fields)

    // 当 config.fields 存在时，将按照 fields 中定义的方式显示
    if (hasFieldsMask) {
      config.fields.forEach((field) => {
        if (field.showType !== 'hidden') {
          const col = columnsMap[field.slug]
          if (col && col.slug !== ID_SLUG) {
            col.__pushed = true
            visibleFields.push({ ...col, ...field })
          }

          if (col && col.slug === ID_SLUG && tableDataIdColumn) {
            col.__pushed = true
            visibleFields.push(tableDataIdColumn)
          }
        }
      })
    }

    // showTypeMode 为 'show' 时， config.fields 中未定义的字段将默认依次显示，否则只显示
    // showTypeMode 不为 'show' 时，则只显示 fields 中定义了的字段
    if (config.showTypeMode === 'show' || !hasFieldsMask) {
      fields.forEach((col) => {
        const obj = config.fields.find((v) => v.slug === col.slug)
        const isShow =
          col.slug &&
          hiddenTableColumnsType.indexOf(col.type) === -1 &&
          !col.__pushed &&
          !col.hidden &&
          (!obj || (obj && obj.showType !== 'hidden'))

        if (isShow && col.slug !== ID_SLUG) {
          visibleFields.push(col)
        }
        if (isShow && col.slug === ID_SLUG && tableDataIdColumn) {
          visibleFields.push(tableDataIdColumn)
        }
      })
    }

    visibleFields.forEach((col) => {
      const options = {
        key: col.slug,
        title: col.title,
        dataKey: col.slug,
        width: col.width || clacWidth(config, idField, visibleFields),
        resizable: col.resizable !== false,
        sortable: col.sortable,
        frozen: clacSticky(col),
        defs: col,
        hooks,
      }

      if (col.slug !== ID_SLUG && col.key !== ID_SLUG) {
        columns.push(options)
      }
      if (col.key === ID_SLUG) {
        columns.push(col)
      }
    })

    if (fixedOperateColumn) {
      columns.push(fixedOperateColumn)
    }

    // 处理合并单元格
    transformColumns(columns, mergeCellInfo)
    return columns
  }
}
